import { createAction } from 'redux-actions';

import { SELECT_MID, SETUP_MID, CLEAR_SELECTED_MID } from '@/constants';

export const selectMid = createAction(SELECT_MID, mid => ({ mid }));
export const setupMid = createAction(SETUP_MID);
export const clearSelectedMid = createAction(CLEAR_SELECTED_MID);
